import { render, staticRenderFns } from "./diagnostic-report.vue?vue&type=template&id=0339fa40&scoped=true&"
import script from "./diagnostic-report.vue?vue&type=script&lang=js&"
export * from "./diagnostic-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0339fa40",
  null
  
)

export default component.exports